<div class="ahe-ui-alert-modal" id="common-modal" [attr.role]="role" tabindex="-1" aria-labelledby="common-modal-title" aria-modal="true"
  cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown.escape)="checkTooltipPresent() ? null : closeModalDialog()">
  <div class="modal-overlay">
    <div class="modal-container-new">
      <div class="modal-dialog" [ngClass]="width ? 'modal-custom-width' : null" [style.--custom-max-width]="width">
        <div class="modal-content">
          <div class="modal-header-set">
            <h2 id="common-modal-title" class="header-text">{{ header }}</h2>
            <button
              app-button
              appTooltip="Close"
              panelClass="fit-overlay"
              type="button"
              class="close"
              aria-label="Close dialog"
              (click)="closeModalDialog()"
            >
              <span class="ahe-icon ahe-icon-close-white" aria-hidden="true"></span>
            </button>
          </div>
          <div class="modal-body" [attr.tabindex]="isScrollable ? '0' : null" [style.color]="bodyTextColor" #modalBody>
            <ng-content></ng-content>
          </div>
          <div class="modal-footer-new" #modalFooter>
            <app-button
              buttonText="Cancel"
              [purpose]="_buttonPurpose.Secondary"
              class="align-left"
              data-dismiss="modal"
              (click)="closeModalDialog()"
            ></app-button>
            <app-button
              [disabled]="disableConfirm"
              buttonText="Confirm"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="closeAndSave()"
            ></app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
